import type { Catalog } from "../en";

/** Web app portal - orders, quotes and approvals - Filipino (Taglish where natural; follows the widget's ordering card words). */
export const webappPortalOrders: Catalog["webapp"]["portal"]["orders"] = {
  nav: { area: "Mga order at quotation", orders: "Mga order", quotes: "Mga quotation", approvals: "Mga approval" },
  area: { title: "Mga order", intro: "Ang mga order mo, mga quotation at ang mga approval na naghihintay sa iyo." },
  off: { title: "Hindi available dito ang pag-order", body: "Hindi tumatanggap ng order sa portal ang workspace na ito. Puwede ka pa ring mag-report ng request at tutulungan ka namin.", cta: "Pumunta sa mga ticket ko" },
  common: {
    back: "Bumalik",
    loadMore: "Magpakita pa",
    loadingMore: "Naglo-load…",
    retry: "Subukan ulit",
    total: "Kabuuan",
    subtotal: "Subtotal",
    vat: "VAT",
    vatEstimated: "VAT (tantiya)",
    inclVat: "kasama ang VAT",
    unpriced: "Presyo kapag hiniling",
    listPrice: "Presyo sa listahan",
    qty: "Dami",
    product: "Produkto",
    unitPrice: "Presyo bawat isa",
    lineTotal: "Kabuuan",
    lines: "{{count}} linya",
    notInvoice: "Hindi ito invoice.",
    reference: "Reference",
    status: "Status",
    placed: "Naipasok",
    created: "Ginawa",
    none: "—",
    offline: "Mukhang offline ka. Suriin ang koneksyon mo at subukan ulit.",
    limited: "Masyadong maraming subok. Maghintay sandali at subukan ulit.",
    failed: "May nangyaring mali sa panig namin. Pakisubukan ulit.",
    notFound: "Hindi namin ito makita. Maaaring sa iba ito o wala na.",
  },
  status: {
    draft: "Draft",
    pending_confirmation: "Naghihintay ng kumpirmasyon mo",
    pending_approval: "Naghihintay ng approval",
    approved: "Aprubado",
    submitting: "Ipinapadala",
    placed: "Naipasok",
    processing: "Pinoproseso",
    partially_shipped: "Bahagyang naipadala",
    shipped: "Naipadala",
    delivered: "Naihatid",
    completed: "Tapos na",
    declined: "Tinanggihan",
    cancel_requested: "Hiniling ang pagkansela",
    cancelled: "Nakansela",
    rejected: "Hindi tinanggap",
    sync_failed: "Sinusuri",
  },
  quoteStatus: { requested: "Naghihintay ng presyo", quoted: "Handa nang tanggapin", accepted: "Tinanggap", declined: "Tinanggihan", expired: "Nag-expire", converted: "Na-order na" },
  approvalStatus: { pending: "Naghihintay", approved: "Aprubado", declined: "Tinanggihan", expired: "Nag-expire", withdrawn: "Binawi" },
  list: {
    title: "Aking mga order",
    new: "Bagong order",
    filter: "Ipakita",
    all: "Lahat ng order",
    open: "Isinasagawa",
    done: "Naihatid",
    cancelled: "Nakansela",
    emptyTitle: "Wala ka pang order",
    emptyBody: "Kapag naglagay ka ng order, makikita ito rito kasama ang status at tracking.",
    emptyFiltered: "Walang order na tumutugma sa filter na ito.",
    errorTitle: "Hindi namin ma-load ang mga order mo",
    po: "PO {{po}}",
    open_: "Buksan ang order {{number}}",
    pendingTitle: "Naghihintay ng kumpirmasyon mo",
  },
  detail: {
    title: "Order {{number}}",
    back: "Lahat ng order",
    items: "Mga item",
    totals: "Kabuuan",
    delivery: "Delivery",
    site: "Site",
    requestedDate: "Gustong petsa",
    poNumber: "PO number",
    paymentTerms: "Termino ng bayad",
    notes: "Mga tala",
    tracking: "Tracking",
    carrier: "Courier",
    trackingNumber: "Tracking number",
    expected: "Inaasahang dating",
    delayed: "Mas huli kaysa inaasahan",
    invoices: "Mga invoice",
    checked: "Sinuri {{when}}",
    timeline: "Ang nangyari",
    refresh: "Tingnan ang status",
    refreshed: "Nasuri na ang status",
    shipped: "{{shipped}} sa {{qty}} ang naipadala",
    rejected: "Hindi tinanggap ang order: {{reason}}",
    errorTitle: "Hindi namin ma-load ang order na ito",
    notFoundTitle: "Hindi nakita ang order",
    confirmNow: "Naghihintay ng kumpirmasyon mo ang order na ito.",
    reviewConfirm: "Suriin at kumpirmahin",
  },
  events: {
    created: "Sinimulan ang order",
    reviewed: "Sinuri mo ang order",
    price_changed: "Nagbago ang isang presyo",
    confirmed: "Kinumpirma mo ang order",
    approval_required: "Naipadala para sa approval",
    queued: "Naghihintay na maipadala",
    note: "Tala mula sa team",
    approval_decided: "Nagdesisyon na sa approval",
    submit_attempt: "Ipinadala sa order system",
    reconciled: "Sinuri sa order system",
    external_status: "Update sa status",
    delayed: "Mas huli ang delivery kaysa inaasahan",
  },
  reject: { out_of_stock: "ubos na ang isang item", price_changed: "nagbago ang isang presyo", credit_hold: "naka-hold ang account", invalid_customer: "hindi pa naka-set up ang customer", other: "hindi ito natanggap ng order system" },
  cancel: {
    button: "Kanselahin ang order na ito",
    requestButton: "Humiling na kanselahin ang order na ito",
    title: "Kanselahin ang order {{number}}?",
    withdraw: "Hindi pa naipapadala ang order na ito. Makakansela ito agad.",
    system: "Hihilingin namin sa order system na kanselahin ito.",
    request: "Hihilingin namin sa team na kanselahin ito. Babalikan ka namin.",
    notAllowed: "Hindi na makakansela rito ang order na ito. Mag-report ng problema at tutulungan ka namin.",
    already: "Nahilingan na ang pagkansela. Sasabihin namin ang desisyon ng team.",
    reason: "Dahilan (opsyonal)",
    keep: "Panatilihin ang order",
    confirm: "Oo, kanselahin",
    done: "Nakansela ang order {{number}}.",
    requested: "Hiniling ang pagkansela. {{ticket}}",
    ticket: "Subaybayan sa ticket {{number}}.",
  },
  issue: {
    button: "May problema sa order na ito",
    title: "Problema sa order {{number}}",
    intro: "Sabihin kung ano ang mali. Magbubukas kami ng request para sa team at iuugnay ito sa order na ito.",
    kind: "Ano ang mali?",
    note: "Mga detalye (opsyonal)",
    lines: "Aling mga item?",
    submit: "Ipadala sa team",
    done: "Salamat. Nagbukas kami ng request {{number}} para sa team.",
    openRequest: "Buksan ang request {{number}}",
    related: "Mga request tungkol sa order na ito",
    kinds: { wrong_item: "Maling item", missing_quantity: "Kulang ang dami", damaged: "Sira", late: "Huli ang delivery", invoice: "Tanong sa invoice", other: "Iba pa" },
  },
  new: {
    title: "Bagong order",
    searchLabel: "Hanapin sa catalogue",
    searchPlaceholder: "Pangalan, SKU o brand",
    searchHelp: "Mag-type ng hindi bababa sa 2 letra. Presyo sa listahan ang ipinapakita hangga't hindi mo sinusuri ang order.",
    results: "Mga produkto",
    noResults: "Walang produktong tumutugma sa “{{q}}”.",
    searchError: "Hindi namin nahanap sa catalogue.",
    paused: "Naka-pause ang pag-order ngayon. Puwede kang mag-browse at humingi ng quotation.",
    add: "Idagdag",
    added: "Naidagdag ang {{name}}",
    cart: "Ang cart mo",
    cartEmpty: "Walang laman ang cart mo",
    cartEmptyBody: "Maghanap ng produkto at idagdag ito para magsimula ng order.",
    remove: "Alisin ang {{name}}",
    qtyOf: "Dami ng {{name}}",
    increase: "Dagdagan ang {{name}}",
    decrease: "Bawasan ang {{name}}",
    clear: "Ubusin ang cart",
    checkout: "Mga detalye ng delivery",
    site: "Delivery site",
    address: "Address ng site",
    po: "PO number",
    date: "Gustong petsa",
    notes: "Mga tala para sa team",
    review: "Suriin ang order",
    reviewing: "Sinusuri ang mga presyo…",
    reviewTitle: "Suriin ang order mo",
    editCart: "Bumalik sa cart",
    inStock: "May stock",
    lowStock: "Kaunti na lang ang stock",
    out: "Ubos na",
    madeToOrder: "Ginagawa kapag inorder",
    unknown: "Availability kapag hiniling",
    minQty: "Pinakamababa: {{qty}}",
  },
  review: {
    title: "Suriin ang order mo",
    number: "Order {{number}}",
    delivery: "Delivery",
    degraded: "Ang ilang presyo ay presyo sa listahan dahil hindi sumagot ang sistema sa tamang oras.",
    stepUp: "Kailangan ng one-time code ang kabuuang ito bago maipadala.",
    approval: "Kailangan ng OK ng approver ang order na ito bago maipadala sa amin.",
    hint: "Pagpindot mo ng button ang kumpirmasyon. Ang pag-type ng “oo” sa chat ay hindi kailanman maglalagay ng order.",
    confirm: "Kumpirmahin ang order",
    confirmNew: "Kumpirmahin gamit ang bagong presyo",
    confirmApproval: "Kumpirmahin at ipadala para sa approval",
    confirming: "Inilalagay ang order mo…",
    changedTitle: "Nagbago ang mga presyo",
    changedBody: "May mga presyong nagbago mula noong huli mong tingnan. Suriin ang bagong kabuuan bago kumpirmahin.",
    ack: "Nasuri ko na ang mga bagong presyo.",
    expiredTitle: "Nag-expire na ang kumpirmasyong ito",
    expiredBody: "Para sa seguridad mo, 30 minuto at isang beses lang gumagana ang kumpirmasyon. Suriin ulit ang order para sa bago.",
    again: "Suriin ulit",
    blocked: "Hindi namin mailagay ang order na ito",
    cancel: "Kanselahin ang order na ito",
    cancelling: "Kinakansela…",
    cancelled: "Nakansela ang order na ito. Walang naipadala.",
    placedTitle: "Salamat! Naipasok na ang order mo.",
    placedReplayed: "Nailagay na ang order na ito.",
    approvalTitle: "Naipadala para sa approval",
    approvalBody: "Naghihintay ng approver ang order {{number}}. Sasabihin namin kapag nagdesisyon na sila.",
    viewOrder: "Tingnan ang order",
    allOrders: "Lahat ng order",
  },
  stepUp: {
    title: "Ilagay ang code mo",
    sent: "Nagpadala kami ng anim na digit na code sa {{email}}.",
    label: "One-time code",
    verify: "I-verify at magpatuloy",
    resend: "Magpadala ng bagong code",
    sending: "Ipinapadala…",
    bad: "Hindi gumana ang code. Suriin ang anim na digit at subukan ulit.",
    back: "Bumalik",
  },
  quotes: {
    title: "Aking mga quotation",
    ask: "Humingi ng quotation",
    emptyTitle: "Wala ka pang quotation",
    emptyBody: "Humingi ng presyo para sa bulk order o espesyal na kailangan at sasagot ang team dito.",
    errorTitle: "Hindi namin ma-load ang mga quotation mo",
    validUntil: "Valid hanggang {{date}}",
    detailTitle: "Quotation {{number}}",
    back: "Lahat ng quotation",
    request: "Ang hiniling mo",
    lines: "Mga na-quote na item",
    accept: "Tanggapin ang quotation",
    acceptNew: "Tanggapin gamit ang bagong presyo",
    decline: "Tanggihan",
    declineTitle: "Tanggihan ang quotation {{number}}?",
    declineReason: "Dahilan (opsyonal)",
    declineConfirm: "Oo, tanggihan",
    update: "Humingi ng bagong quote",
    updateDone: "Hiniling namin sa team na i-presyo ulit ito.",
    expiredNote: "Nag-expire na ang quotation na ito. Maaaring nagbago na ang mga presyo.",
    ticket: "Sinusubaybayan sa request {{number}}",
    order: "Order {{number}}",
    accepted: "Tinanggap ang quotation.",
    needsStaff: "Tinanggap ang quotation. May mga item na ipinepresyo nang mano-mano, kaya ilalagay ng team ang order at sasabihin sa iyo.",
    declined: "Tinanggihan ang quotation.",
    priceChanges: "May mga presyong nagbago mula sa quotation na ito",
    priceChangesBody: "Suriin ang mga pagbabago sa ibaba. Kapag tinanggap mo ulit, kukunin ang bagong presyo.",
    review: "Kumpirmahin ang order mula sa quotation na ito",
    askTitle: "Humingi ng quotation",
    askIntro: "Ilista ang mga produkto at dami, o ilarawan ang kailangan mo. Walang ipapadala hangga't hindi mo pinipindot ang button.",
    askText: "Ano ang kailangan mo?",
    askPlaceholder: "hal. Nitrile gloves, medium, box ng 100",
    askQty: "Dami",
    askNotes: "May iba pa bang dapat malaman ng team? (opsyonal)",
    askSend: "Ipadala ang request",
    askSent: "Naipadala ang request {{number}}. Ipepresyo ito ng team at sasagot dito.",
    askRequired: "Sabihin kung ano ang kailangan mo.",
  },
  approvals: {
    title: "Mga approval",
    tabPending: "Naghihintay",
    tabDecided: "Nadesisyunan",
    emptyPending: "Walang naghihintay ng approval",
    emptyPendingBody: "Kapag kailangan ng OK mo ang order ng kasamahan, makikita ito rito.",
    emptyDecided: "Wala pang desisyon",
    emptyDecidedBody: "Makikita rito ang mga inaprubahan at tinanggihang order.",
    errorTitle: "Hindi namin ma-load ang mga approval",
    requestedBy: "Hiniling ni {{name}}",
    mine: "Ang order mo",
    expires: "Mag-e-expire sa {{date}}",
    open: "Suriin",
    detailTitle: "Approval para sa order {{number}}",
    reasons: "Bakit kailangan ng approval",
    reason: {
      contact_limit: "Lampas sa limit ng bumibili",
      org_threshold: "Lampas sa threshold ng organisasyon",
      staff_threshold: "Lampas sa halagang inaaprubahan ng team namin",
      credit_status: "Naka-credit hold ang account",
      line_category: "May item na kailangan ng approval",
      anomaly: "Hindi karaniwang order",
    },
    note: "Tala (opsyonal)",
    approve: "Aprubahan",
    approving: "Ina-aprubahan…",
    decline: "Tanggihan",
    declineTitle: "Tanggihan ang order na ito?",
    declineReason: "Dahilan",
    declineRequired: "Sabihin kung bakit, para malaman ng bumibili.",
    declineConfirm: "Oo, tanggihan",
    withdraw: "Bawiin ang order ko",
    needsReview: "Nagbago ang mga presyo",
    needsReviewBody: "Binasa ulit ang mga presyo at nasa {{percent}}% na mas mataas. Suriin ang bagong kabuuan, saka aprubahan.",
    outOfStock: "Ubos na ngayon: {{skus}}",
    ack: "Nasuri ko na ang mga bagong presyo.",
    approved: "Naaprubahan. Papunta na sa amin ang order.",
    declinedDone: "Tinanggihan. Nasabihan ang bumibili.",
    withdrawn: "Binawi ang order mo.",
    cannotDecide: "Masusubaybayan mo rito ang order na ito. Approver ang magdedesisyon.",
    decidedBy: "{{status}} ni {{name}} noong {{date}}",
    stepUp: "Kailangan muna ng one-time code para aprubahan ang malaking kabuuan.",
  },
  confirm: {
    title: "Kumpirmahin ang order mo",
    intro: "Sinimulan mo ang order na ito sa chat. Suriin ito, saka pindutin ang button.",
    missing: "Hindi sinasabi ng link na ito kung para saang order.",
    missingBody: "Buksan ang mga order mo para hanapin ito, o magtanong ulit sa assistant.",
    loadError: "Hindi namin ma-load ang order na ito",
    notWaiting: "Hindi na naghihintay ng kumpirmasyon mo ang order na ito.",
    viewOrders: "Aking mga order",
  },
};
